/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Page from 'material/structure/page/page';
import Section from 'material/section/section';
import Content from 'material/structure/content/content';
import Copy from 'material/copy/copy';
import Title from 'material/copy/title/title';
import Link from 'material/ctas/link/link_container';
import Grid from 'material/grid/grid';
import GridSet from 'material/grid/gridset/gridset';
import GridItem from 'material/grid/griditem/griditem';
import Icon from 'material/graphic/icon/icon';
import DateRangePickerDropDown from 'material/dropdowns/daterangepickerdropdown/daterangepickerdropdown';
import Table from 'material/table/table';
//utils
import { isAfterFourPM } from 'utils/isafterfourpm';
import { transpileByStoryTableBody, transpileByStoryTableColumnHead } from 'utils/data_visualization_transpilers';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/analytics/detail/metrics/topstoryclicks/topstoryclicks_styles';




/* ========== ~~~~~~~~~~ PAGE : DATA DETAIL : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class TopStoryClicks extends Component {
    constructor(props){
        super(props);
        this.state = {
            indexClicked: null
        };
    }

    componentWillMount(){
        this.props.getTopStoryClicks(`&accountUUID=${this.props.accountUUID}&startDate=${this.props.dateRange.from}&endDate=${this.props.dateRange.to}`);

    }

    componentWillUnmount(){
        this.props.clearDetailState();
    }

    handleDateRangeApply = ()=>{
        this.props.getTopStoryClicks(`&accountUUID=${this.props.accountUUID}&startDate=${this.props.dateRange.from}&endDate=${this.props.dateRange.to}`);
    };

    linkToEmbed = (index, embedUUID) => {
        this.setState({indexClicked: index}); //this will be reset when homepage loads
        const accountUUID = this.props.isDataReceived ? false : this.props.accountUUID;
        this.props.viewAnalytics(embedUUID, accountUUID);
    };
    //this method returns props needed to export all data that is shown on detailTable to an excel sheet
    //it takes in fileName, and excludedColumns
    //since I am passing various props that arent data specific in to the table component I need to exclude things like disabled, handleRowClick, etc.
    exportProps = () => ({ fileName: 'Top Clicked Stories', excludedColumns: ['question_uuid', 'embed_uuid', 'processing', 'handleRowClick', 'disabled', ''] });

    render() {

        return(
            <Page name={`topstoryclicks`} klass={`${this.props.classes.topstoryclicks}`}>
                <Content>

                    <Section name={`tabledetailheader`}>
                        <Grid>
                            <GridSet direction={`horizontal`} name={`tabledetailtitle`}>
                                <GridItem>
                                    <Copy>
                                        <Link type={`internal`} behavior={`back`} text={`Back to all metrics`} color={`primary`} action={`dashboard/home`} icon={<Icon name={`hand-point-left`} />} />
                                        <Title><h2>{'Most Clicked Stories'}</h2></Title>
                                    </Copy>
                                </GridItem>
                                <GridItem>
                                    <DateRangePickerDropDown updateRange={this.props.updateDateRange} range={this.props.dateRange} disabledDays={[ { after: new Date(new Date() - (isAfterFourPM() ? (1000 * 60 * 60 * 24) : (1000 * 60 * 60 * 24 * 2))) } ]} handleApply={this.handleDateRangeApply}/>
                                </GridItem>
                            </GridSet>
                        </Grid>
                    </Section>

                    <Section name={`tabledetailtable`}>
                        <Table
                            name={`rank`}
                            type={`fixed-column`}
                            fixedColWidth={75}
                            size={`full`}
                            columnHeads={transpileByStoryTableColumnHead(true)}
                            data={transpileByStoryTableBody(this.props.topStoryClicks, this.linkToEmbed, this.state.indexClicked)}
                            showTitle={true}
                            exportData={this.exportProps()}
                            paginationLocation={`top`}
                            rowsPerPage={15}
                            clickableRow={true}
                            loading={this.props.topStoryClicksFetching}
                            moreDetails={false}
                        />
                    </Section>

                </Content>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(TopStoryClicks);